import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationUserTable from '../components/OrganisationUserTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import DismissableAlert from '../components/DismissableAlert';
import Dialog from 'react-bootstrap-dialog';

import axios from 'axios';
import {
	Panel,
	Col,
	Row,
	Button,
	FormControl,
	FormGroup,
	InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationUsers.css';

class OrganisationUsers extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: props.user,
			userIsAuthorized: props.userIsAuthorized,
			user: props.user,
			users: [],
			page: props.page,
			pageCount: 0,
			limit: 40,
			search: '',
			selected: props.selected - 1,
			error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            },
			selectedUsers: new Set(),
			selectedUsersData: new Map(),
			selectAllMode: false,
			totalUsers: 0,
			excludedUsers: new Set(),
			excludedUsersData: new Map()
		};
	}
	

	deleteUser(user) {

		const { uuid } = this.props.match.params;

        var self = this;
        axios
            .delete(`${config.baseURL}/organisations/${uuid}/users/${user.uuid}`)
            .then(function(response) {
                self.loadOrganisationUsersFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

	onUserRoleSelected(user, role) {

		const { uuid } = this.props.match.params;

        var self = this;
        axios
            .put(`${config.baseURL}/organisations/${uuid}/users/${user.uuid}/role`, {
				role
			})
            .then(function(response) {
                self.loadOrganisationUsersFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }


	componentDidMount() {
		this.loadOrganisationInformation();
		this.loadOrganisationUsersFromServer();
	}

	loadOrganisationInformation() {
		var self = this;

		const { uuid } = this.props.match.params;

		axios
			.get(`${config.baseURL}/organisations/${uuid}`, {})
			.then(function (response) {
				self.setState({
					organisation_name: response.data.organisation.name
				});
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	disableUser2FA(user, password, token) {

		const { t } = this.props;

        var self = this;
        axios
            .post(`${config.baseURL}/users/${user.uuid}/disable2FA`, {
                password,
                authToken: token
            })
            .then(function(response) {
                self.loadOrganisationUsersFromServer();
            })
            .catch(function(error) {
				self.setState({
					error: {
						hidden: false,
						title: `${t('OrganisationUsers.error')}:`,
						style: 'danger',
						message: "Unable to disable 2FA. Please check the password and token provided."
					}
				});
            });
    }

	loadOrganisationUsersFromServer() {
		var self = this;
		const { uuid } = this.props.match.params;

		axios
			.get(`${config.baseURL}/organisations/${uuid}/users`, {
				params: {
					page: self.state.page,
					limit: self.state.limit,
					search: self.state.search
				}
			})
			.then(function (response) {
				self.setState({
					users: response.data.users,
					pageCount: response.data.pageCount,
					totalUsers: response.data.itemCount
				});

				console.log(`Users: ${JSON.stringify(response.data.users)}`);

			})
			.catch(function (error) {
				console.log(error);
			});
	}

	handlePageClick = data => {
		let selected = data.selected + 1;

		const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
			this.loadOrganisationUsersFromServer();
		});
	};

	handleChange = event => {
		this.setState({
			[event.target.id]: event.target.value
		});
	};

	handleSubmit = event => {
		const { t } = this.props;

		const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url);

		event.preventDefault();
		this.loadOrganisationUsersFromServer();
	};

	handleSelectUser = (userUuid, isSelected) => {
		let selectedUsers = new Set(this.state.selectedUsers);
		let selectedUsersData = new Map(this.state.selectedUsersData);
		let excludedUsers = new Set(this.state.excludedUsers);
		let excludedUsersData = new Map(this.state.excludedUsersData);

		if (isSelected) {
			if (this.state.selectAllMode) {
				excludedUsers.delete(userUuid);
				excludedUsersData.delete(userUuid);
			} else {
				selectedUsers.add(userUuid);
				const userData = this.state.users.find(u => u.uuid === userUuid);
				if (userData) {
					selectedUsersData.set(userUuid, userData);
				}
			}
		} else {
			if (this.state.selectAllMode) {
				excludedUsers.add(userUuid);
				const userData = this.state.users.find(u => u.uuid === userUuid);
				if (userData) {
					excludedUsersData.set(userUuid, userData);
				}
			} else {
				selectedUsers.delete(userUuid);
				selectedUsersData.delete(userUuid);
			}
		}

		this.setState({
			selectedUsers,
			selectedUsersData,
			excludedUsers,
			excludedUsersData
		});
	};

	handleSelectAll = (isSelectAll) => {
		if (isSelectAll) {
			this.setState({
				selectAllMode: true,
				selectedUsers: new Set(),
				selectedUsersData: new Map(),
				excludedUsers: new Set(),
				excludedUsersData: new Map()
			});
		} else {
			this.setState({
				selectAllMode: false,
				selectedUsers: new Set(),
				selectedUsersData: new Map(),
				excludedUsers: new Set(),
				excludedUsersData: new Map()
			});
		}
	};

	showBulkDeleteConfirmation = () => {
		const { t } = this.props;

		let bodyContent;

		if (this.state.selectAllMode) {
			const effectiveCount = this.state.totalUsers - this.state.excludedUsers.size;
			bodyContent = (
				<div>
					<p><strong>Warning: This will remove {effectiveCount} users from this organisation!</strong></p>
					<p>This includes all users that match your current search {this.state.search ? ` for "${this.state.search}"` : ''}
					{this.state.excludedUsers.size > 0 && <span>, excluding {this.state.excludedUsers.size} manually deselected items</span>}.</p>
					<p><em>This action cannot be undone.</em></p>
				</div>
			);
		} else {
			const selectedItems = Array.from(this.state.selectedUsersData.values());
			bodyContent = (
				<div>
					<p><strong>This will remove {selectedItems.length} selected users from this organisation:</strong></p>
					<ul style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '10px' }}>
						{selectedItems.map(item => (
							<li key={item.uuid}><strong>{item.firstName} {item.lastName}</strong> ({item.email})</li>
						))}
					</ul>
				</div>
			);
		}

		this.dialog.show({
			title: t('Dialog.warning'),
			body: bodyContent,
			actions: [
				Dialog.Action(
					t('Dialog.cancel'),
					() => this.dialog.hide(),
					'btn-default'
				),
				Dialog.Action(
					t('Dialog.remove'),
					() => this.confirmBulkDelete(),
					'btn-danger'
				)
			],
			bsSize: 'large'
		});
	};

	handleBulkDelete = () => {
		this.showBulkDeleteConfirmation();
	};

	confirmBulkDelete = () => {
		const { uuid } = this.props.match.params;

		const payload = {
			selectAll: this.state.selectAllMode,
			search: this.state.search,
			users: this.state.selectAllMode ? [] : Array.from(this.state.selectedUsers),
			excludedUsers: this.state.selectAllMode ? Array.from(this.state.excludedUsers) : []
		};

		const wasSelectAllWithSearch = this.state.selectAllMode && this.state.search;

		axios
			.post(`${config.baseURL}/organisations/${uuid}/users/bulk-delete`, payload)
			.then((response) => {
				const newState = {
					selectedUsers: new Set(),
					selectedUsersData: new Map(),
					excludedUsers: new Set(),
					excludedUsersData: new Map(),
					selectAllMode: false
				};

				if (wasSelectAllWithSearch) {
					newState.search = '';

					const url = new URL(window.location.href);
					url.searchParams.delete('search');
					window.history.pushState(null, null, url);
				}

				this.setState(newState, () => {
					this.loadOrganisationUsersFromServer();
				});
			})
			.catch(function(error) {
				console.log(error);
				this.setState({
					error: {
						hidden: false,
						title: `${this.props.t('Dialog.error')}:`,
						style: 'danger',
						message: (error.response && error.response.data && error.response.data.message) || 'Failed to remove users'
					}
				});
			}.bind(this));
	};

	render() {
		const { t } = this.props;
		document.title = `MySign Digital Screen Solutions | ${t(
			'Users.title'
		)}`;

		const selectedCount = this.state.selectAllMode
			? this.state.totalUsers - this.state.excludedUsers.size
			: this.state.selectedUsers.size;
		const hasSelection = selectedCount > 0;

		const user = this.state.user;
		const { uuid } = this.props.match.params;

		return (
			<div className="OrganisationUsers">
				<Dialog
					ref={el => {
						this.dialog = el;
					}}
				/>
				<div id="wrapper">
					<Navigation props={this.props} />
					<div id="content-wrapper">
						<Row>
							<Col lg={12}>
								<h1 className="page-header">
									{t('Users.title')}{' '}
									<small>
										{this.state.organisation_name}
									</small>
									{this.state.userIsAuthorized(user, [
										'staff_super_admin',
										'staff_admin',
										'organisation_admin'
									]) ? (<>
										<Link
												type="submit"
												className="btn btn-primary header-button"
												to={`/organisations/${uuid}/users/invites`}
											>
												<em className="fa fa-users fa-fw" />{' '}
												{t('OrganisationUsers.invites')}
											</Link>
											{' '}
											<Link
												type="submit"
												className="btn btn-primary header-button"
												to={`/organisations/${uuid}/users/invite`}
											>
												<em className="fa fa-plus fa-fw" />{' '}
												{t('OrganisationUsers.invite_user')}
											</Link></>
											
										) : null}
								</h1>

								<ol className="breadcrumb">
									<li>
										<i className="fa fa-tachometer-alt" />{' '}
										<Link to={`/organisations/${uuid}`}>
											{t('Dashboard.title')}
										</Link>
									</li>

									<li className="active">
										<i className="fas fa-users" />{' '}
										{t('SideNavigation.users')}
									</li>
								</ol>

								<DismissableAlert
									title={this.state.error.title}
									message={this.state.error.message}
									hidden={this.state.error.hidden}
									style={this.state.error.style}
								/>
								<PaginationPanel
									heading={
										<Row>
											<Col xs={12} className="text-right">
												<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '15px' }}>
													<form
														role="search"
														onSubmit={this.handleSubmit}
														style={{ flex: hasSelection ? 1 : 1 }}
													>
														<FormGroup controlId="search" style={{ margin: 0 }}>
															<InputGroup style={{ height: '38px' }}>
																<FormControl
																	type="text"
																	value={this.state.search}
																	onChange={this.handleChange}
																	placeholder={t('Search')}
																	style={{ height: '38px' }}
																/>
																<InputGroup.Button>
																	<Button
																		onClick={this.handleSubmit}
																		style={{ height: '38px' }}
																	>
																		<i className="glyphicon glyphicon-search" />
																	</Button>
																</InputGroup.Button>
															</InputGroup>
														</FormGroup>
													</form>

													{hasSelection && (
														<div className="alert alert-info" style={{
															display: 'flex',
															justifyContent: 'space-between',
															alignItems: 'center',
															margin: 0,
															padding: '8px 16px',
															fontSize: '14px',
															whiteSpace: 'nowrap',
															flex: 2,
															minWidth: '350px',
															height: '38px',
															borderRadius: '4px'
														}}>
															<span>
																<strong>{selectedCount}</strong> user{selectedCount === 1 ? '' : 's'} selected
																{this.state.selectAllMode && <span> (all pages)</span>}
															</span>
															<div style={{ display: 'flex', gap: '10px' }}>
																<Button
																	className="btn-default btn-sm"
																	onClick={() => {
																		this.setState({
																			selectedUsers: new Set(),
																			selectedUsersData: new Map(),
																			excludedUsers: new Set(),
																			excludedUsersData: new Map(),
																			selectAllMode: false
																		});
																	}}
																	style={{ fontSize: '12px' }}
																>
																	<em className='far fa-square' /> {t('MediaSnippetMediaLibrary.select_none')}
																</Button>
																<Button
																	className="btn-danger btn-sm"
																	onClick={this.handleBulkDelete}
																	style={{ fontSize: '12px' }}
																>
																	<em className="fa fa-trash" /> Remove Selected
																</Button>
															</div>
														</div>
													)}
												</div>
											</Col>
										</Row>
									}
									pagination={
										<ReactPaginate
											previousLabel={t(
												'Pagination.previous'
											)}
											nextLabel={t('Pagination.next')}
											breakLabel={<Link to="#">...</Link>}
											breakClassName={'break-me'}
											pageCount={this.state.pageCount}
											marginPagesDisplayed={2}
											pageRangeDisplayed={5}
											onPageChange={this.handlePageClick}
											containerClassName={'pagination'}
											subContainerClassName={
												'pages pagination'
											}
											activeClassName={'active'}
											forcePage={this.state.selected}
										/>
									}
								>
									<OrganisationUserTable
										userIsAuthorized={this.state.userIsAuthorized}
										user={this.state.user}
										users={this.state.users}
										uuid={uuid}
										onDelete={this.deleteUser.bind(this)}
										onUserRoleSelected={this.onUserRoleSelected.bind(this)}
										onDisable2FA={this.disableUser2FA.bind(this)}
										onSelectUser={this.handleSelectUser}
										onSelectAll={this.handleSelectAll}
										selectedUsers={this.state.selectedUsers}
										excludedUsers={this.state.excludedUsers}
										selectAllMode={this.state.selectAllMode}
									/>
								</PaginationPanel>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		);
	}
}

export default translate('translations')(OrganisationUsers);
